<template>
  <div class="add-company">
    <div class="page-title bg_white">{{ type ? '添加客户' : '成为vip客户' }}</div>

    <el-form label-width="160px" size="small" :model="submit_form" :rules="rules" ref="form" class="bg_white p20">
      <div class="form company-form">
        <div class="form-section-title">企业信息</div>
        <el-form-item label="公司名称" prop="company_name">
          <el-autocomplete
              v-model="submit_form.company_name"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入内容"
              @select="handleSelect"
              style="width: 100%;"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="company_taxno">
          <el-input v-model="submit_form.company_taxno"/>
        </el-form-item>
        <!-- 客户分类：中间商无需填写设备信息，其余分类必填设备 -->
        <el-form-item label="客户分类" prop="source">
          <el-radio-group v-model="submit_form.source">
            <el-radio
                v-for="item in source_list"
                :key="item.value"
                :label="item.value"
            >{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="匹配行业" prop="industry_ids">
          <el-cascader
              v-model="submit_form.industry_ids"
              :options="industryOptions"
              :props="{ value: 'key', label: 'title' }"
              clearable
              placeholder="请选择匹配行业"
              style="width: 100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="生产产品" prop="product">
          <div class="product-picker" @click="openProductDialog">
            <el-input
                v-model="submit_form.product"
                readonly
                placeholder="请选择生产产品"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="公司地址" prop="test_address">
          <select-address-cascader v-model="submit_form.test_address"/>

          <div class="mt20">
            <el-form-item label-width="0" prop="company_address" style="width: 100%;">
              <el-input
                  v-model="submit_form.company_address"
                  rows="4"
                  placeholder="详细地址"
                  type="textarea"/>
            </el-form-item>
          </div>
        </el-form-item>

        <el-form-item label="公司电话" prop="company_tel">
          <el-input v-model="submit_form.company_tel"/>
        </el-form-item>

        <el-form-item label="代表人" prop="agent_name">
          <el-input v-model="submit_form.agent_name"/>
        </el-form-item>
        <div class="form-section-title mt30">管理员信息</div>
        <el-form-item label="管理员" prop="contact_name">
          <el-input v-model="submit_form.contact_name"/>
        </el-form-item>

        <el-form-item label="性别" prop="member_sex">
          <el-radio-group v-model="submit_form.member_sex">
            <el-radio :label="i.dict_data_value" v-for="i in sex_list" :key="i.id">{{ i.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="管理员电话" prop="contact_mobile">
          <el-input v-model="submit_form.contact_mobile"/>
        </el-form-item>

        <el-form-item label="管理员岗位" prop="contact_position">
          <el-select v-model="submit_form.contact_position" placeholder="请选择">
            <el-option v-for="item in position_options" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="开户银行">
          <el-input v-model="submit_form.company_bank_name"/>
        </el-form-item>
        <el-form-item label="银行卡号">
          <el-input v-model="submit_form.company_bank_no"/>
        </el-form-item>

        <el-form-item label>
          <div style="color: #E63212">注：以上信息均为必填信息。如实填写有助于更快通过审核。</div>
        </el-form-item>
        <div class="form-section-title mt30">资质信息</div>
        <el-form-item label="公司logo:">
          <upload-img :file_list.sync="submit_form.company_logo" :limit="1"></upload-img>
        </el-form-item>

        <el-form-item label="其他证照:">
          <div style="color: #666666">图片仅支持.jpeg、.png格式</div>
          <upload-img :file_list.sync="submit_form.company_certificate_imgs" :limit="5"></upload-img>
        </el-form-item>
      </div>

      <!-- ==================== 设备信息 ==================== -->
      <div class="form company-form">
        <div class="form-section-title mt30">
          设备信息 <span style="color: red" v-if="!isMiddleman">*</span>
        </div>
        <el-form-item label="设备列表" prop="companyDeviceBeans">
          <div>
            <!-- 添加设备按钮 -->
            <el-button type="primary" size="small" @click="openAddDevice">
              + 添加设备
            </el-button>

            <!-- 设备列表表格 -->
            <el-table
              v-if="submit_form.companyDeviceBeans.length"
              :data="submit_form.companyDeviceBeans"
              style="width: 100%; margin-top: 10px"
              size="small"
              border
              max-height="300"
            >
              <el-table-column
                type="index"
                label="序号"
                width="55"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="device_name"
                label="设备名称"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="company_device_name"
                label="设备别名"
                min-width="120"
              ></el-table-column>
              <el-table-column
                label="操作"
                width="130"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="editDevice(scope.$index)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    style="color: red"
                    @click="deleteDevice(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>

            <!-- 空状态占位 -->
            <div
              v-if="!submit_form.companyDeviceBeans.length"
              style="
                color: #999;
                text-align: center;
                padding: 20px;
                border: 1px dashed #dcdfe6;
                border-radius: 4px;
                margin-top: 10px;
              "
            >
              暂无设备信息，请点击上方"添加设备"按钮添加
            </div>
            <!-- 必填提示：中间商可不填 -->
            <div style="color: #999; font-size: 12px; margin-top: 5px">
              {{ isMiddleman ? "中间商可不填设备信息" : "至少添加一个设备" }}
            </div>
          </div>
        </el-form-item>
      </div>

      <div class="fr jc ac mb50 mt50">
        <el-button type="primary" style="width: 315px" @click="submit">提交</el-button>
      </div>
    </el-form>

    <el-dialog
        :visible.sync="showHandleProduct"
        title="完善生产产品信息"
        width="800px"
        append-to-body
        @open="getProductList"
    >
      <div class="product-dialog-body">
        <el-input
            placeholder="请输入产品名称检索"
            clearable
            v-model="productKeyword"
            class="mb20"
        ></el-input>
        <div v-if="filterProductList.length" class="product-tag-list">
          <div
              v-for="item in filterProductList"
              :key="item.id || item.tag_id || item.tag_name"
              class="product-tag"
              :class="{ active: item.checked }"
              @click="checkProduct(item)"
          >
            {{ item.tag_name }}
          </div>
        </div>
        <div v-else class="product-empty">暂无生产产品</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="confirmProduct">确认</el-button>
        <el-button type="primary" size="medium" @click="addProduct">添加产品</el-button>
      </span>
    </el-dialog>

    <!-- ========== 设备添加/编辑对话框 ========== -->
    <el-dialog
      :visible.sync="deviceDialogVisible"
      :title="deviceEditIndex === -1 ? '添加设备' : '编辑设备'"
      width="500px"
      append-to-body
    >
      <el-form
        ref="deviceFormRef"
        :model="deviceForm"
        label-width="140px"
        size="small"
      >
        <!-- 设备类型（使用级联选择器） -->
        <el-form-item label="设备类型" prop="device_id">
          <el-cascader
            v-model="deviceForm.device_id"
            :options="deviceColumns"
            :props="{ children: 'deviceBeans', label: 'text', value: 'value' }"
            filterable
            clearable
            placeholder="请选择设备类型"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <!-- 设备别名 -->
        <el-form-item label="设备别名">
          <el-input v-model="deviceForm.company_device_name"></el-input>
        </el-form-item>
        <!-- 气缸直径 -->
        <el-form-item label="气缸直径(内)(cm)">
          <el-input
            v-model="deviceForm.cylinder_diameter"
            type="number"
          ></el-input>
        </el-form-item>
        <!-- 主动辊直径 -->
        <el-form-item label="主动辊直径(cm)">
          <el-input
            v-model="deviceForm.master_roller_diameter"
            type="number"
          ></el-input>
        </el-form-item>
        <!-- 被动辊直径 -->
        <el-form-item label="被动辊直径(cm)">
          <el-input
            v-model="deviceForm.slave_roller_diameter"
            type="number"
          ></el-input>
        </el-form-item>
        <!-- 气缸长度 -->
        <el-form-item label="气缸长度(cm)">
          <el-input
            v-model="deviceForm.cylinder_length"
            type="number"
          ></el-input>
        </el-form-item>
        <!-- 调节辊范围 -->
        <el-form-item label="调节辊范围">
          <el-input v-model="deviceForm.adjuster_roller_range"></el-input>
        </el-form-item>
        <!-- 设备备注 -->
        <el-form-item label="设备备注">
          <el-input
            v-model="deviceForm.remarks"
            type="textarea"
            :rows="3"
            resize="none"
          ></el-input>
        </el-form-item>
        <!-- 设备图片 -->
        <el-form-item label="设备图片">
          <upload-img
            :file_list.sync="deviceForm.company_device_img"
            :limit="1"
          ></upload-img>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="deviceDialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="confirmDevice"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>

import UploadImg from "../../components/UploadImg";

export default {
  data() {
    let checkCompanyTaxNo = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入统一社会信用代码'));
      }
      if (value.length !== 18) {
        return callback(new Error('请输入正确的统一社会信用代码'));
      }
      let res = await this.post("companyInterfaces/v1.0/getCompanyByTaxNo", {company_taxno: value})
      if (this.is_Empty(res.data)) return callback();
      callback(new Error("当前输入的统一社会信用代码已存在！"))
    }
    return {
      file_list: [],
      type: 0,
      //
      address: [],
      showHandleProduct: false,
      productKeyword: "",
      productList: [],
      industry_list: [],
      rules: {
        company_name: {required: true, message: "请输入公司名称", trigger: "blur"},
        company_taxno: {required: true, validator: checkCompanyTaxNo, trigger: "blur"},
        industry_ids: {required: true, message: "请选择匹配行业", trigger: "change"},
        product: {required: true, message: "请选择生产产品", trigger: "change"},
        agent_name: {required: true, message: '请输入代表人', trigger: 'blur'},
        test_address: {required: true, message: '请选择公司地址', trigger: 'blur'},
        company_address: {required: true, message: "请输入公司地址", trigger: "blur"},
        company_tel: {required: true, message: "请输入公司电话", trigger: "blur"},
        contact_name: {required: true, message: "请输入管理员", trigger: "blur"},
        contact_mobile: {required: true, message: "请输入管理员电话", trigger: "blur"},
        contact_position: {required: true, message: "请选择管理员岗位", trigger: "blur"},
        member_sex: {required: true, message: "请选择性别", trigger: "blur"},
        source: {required: true, message: "请选择客户分类", trigger: "change"},
      },
      //提交表单信息
      submit_form: {
        company_name: "",
        agent_name: "",
        member_sex: "",
        company_logo: [],
        company_province: "",
        company_city: "",
        company_country: "",
        company_address: "",
        company_tel: "",
        company_taxno: "",
        source: "",//客户分类
        company_bank_name: "",
        company_bank_no: "",
        contact_name: "",
        contact_mobile: "",
        contact_position: "",
        company_certificate_imgs: [],
        company_remark: "",
        test_address: [],
        industry_ids: [],
        product: "",
        trade_scope: "domestic",//贸易范围
        // ========== 设备列表（本地暂存多个设备，提交客户时一起发送） ==========
        companyDeviceBeans: [],
      },
      sex_list: [],
      position_options: ["负责人", "财务", "采购", "技术员"],
      // 客户分类选项
      source_list: [
        {value: "machinery_manufacturers", label: "机械厂商"},
        {value: "middleman", label: "中间商"},
        {value: "end_user", label: "最终用户"},
        {value: "foreign_users", label: "国外用户"},
      ],
      // ========== 设备管理状态 ==========
      deviceDialogVisible: false, // 设备添加/编辑对话框是否显示
      deviceEditIndex: -1, // 当前编辑的设备索引，-1 为新增
      deviceForm: {}, // 对话框中的设备表单数据
      deviceColumns: [], // 设备级联选择器选项（从 API 获取）
    };
  },
  computed: {
    // 是否为中间商：中间商无需填写设备信息
    isMiddleman() {
      return this.submit_form.source === "middleman";
    },
    industryOptions() {
      if (this.industry_list && this.industry_list.length) return this.industry_list;
      if (this.$store && this.$store.state && this.$store.state.industry_list) {
        return this.$store.state.industry_list;
      }
      return [];
    },
    filterProductList() {
      const keyword = (this.productKeyword || "").trim();
      if (!keyword) return this.productList;
      return this.productList.filter(item => item.tag_name && item.tag_name.indexOf(keyword) !== -1);
    }
  },
  mounted() {
    this.type = this.$route.query.type || 0;
    this.getDictDataList();
    this.getIndustryList();
    // ========== 获取设备列表（用于设备级联选择器） ==========
    this.getDeviceClass();
  },
  methods: {
    // ========== 设备管理相关方法 ==========

    // 获取设备列表（构建设备级联选择器的选项）
    getDeviceClass() {
      this.post("goodsInterfaces/v1.0/getDeviceList", {}).then((res) => {
        let arr = res.data || [];
        let columns = [];
        arr.forEach((el) => {
          let children = [];
          if (el.deviceBeans && el.deviceBeans.length) {
            el.deviceBeans.forEach((e) => {
              children.push({
                text: e.device_name,
                value: e.device_id,
                device_id: e.device_id,
              });
            });
          }
          columns.push({
            text: el.class_name,
            value: el.class_id,
            class_id: el.class_id,
            deviceBeans: children,
          });
        });
        this.deviceColumns = columns;
      });
    },

    // 打开添加设备对话框
    openAddDevice() {
      this.deviceEditIndex = -1; // -1 表示新增
      this.deviceForm = { company_device_img: [] }; // 重置表单
      this.deviceDialogVisible = true;
    },

    // 编辑指定索引的设备
    editDevice(index) {
      this.deviceEditIndex = index;
      // 深拷贝设备数据，避免对话框中修改影响原数据
      let deviceData = JSON.parse(
        JSON.stringify(this.submit_form.companyDeviceBeans[index]),
      );
      // 将单值 device_id 转为级联选择器需要的数组格式 [class_id, device_id]
      if (deviceData.device_id && typeof deviceData.device_id === "number") {
        for (let group of this.deviceColumns) {
          if (group.deviceBeans && group.deviceBeans.length) {
            let found = group.deviceBeans.find(
              (item) => item.device_id === deviceData.device_id,
            );
            if (found) {
              deviceData.device_id = [group.class_id, deviceData.device_id];
              break;
            }
          }
        }
      }
      this.deviceForm = deviceData;
      this.deviceDialogVisible = true;
    },

    // 删除指定索引的设备
    deleteDevice(index) {
      this.$confirm("确定要删除该设备信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submit_form.companyDeviceBeans.splice(index, 1);
          this.$message.success("已删除");
        })
        .catch(() => {});
    },

    // 确认设备表单（校验并存入 companyDeviceBeans）
    confirmDevice() {
      // 必填校验：设备类型和设备别名
      if (
        !this.deviceForm.device_id ||
        !this.deviceForm.device_id.length
      ) {
        this.$message.error("请选择设备类型");
        return;
      }
      if (!this.deviceForm.company_device_name) {
        this.$message.error("请输入设备别名");
        return;
      }

      // 构造存入列表的设备对象
      let deviceData = {
        ...this.deviceForm,
        // 级联选择器的值取最后一级（具体设备 ID）
        device_id: this.deviceForm.device_id[this.deviceForm.device_id.length - 1],
      };
      // 从级联选项中提取设备显示名称
      deviceData.device_name = this.getDeviceNameFromColumns(deviceData.device_id);

      if (this.deviceEditIndex === -1) {
        // 新增：追加到列表末尾
        this.submit_form.companyDeviceBeans.push(deviceData);
      } else {
        // 编辑：替换对应索引的数据
        this.submit_form.companyDeviceBeans.splice(
          this.deviceEditIndex,
          1,
          deviceData,
        );
      }
      this.deviceDialogVisible = false;
    },

    // 从级联选项中根据 device_id 查找设备名称
    getDeviceNameFromColumns(deviceId) {
      for (let group of this.deviceColumns) {
        if (group.deviceBeans && group.deviceBeans.length) {
          let found = group.deviceBeans.find(
            (item) => item.device_id === deviceId,
          );
          if (found) return found.text;
        }
      }
      return "";
    },

    getIndustryList() {
      if (this.industryOptions.length) return;
      this.post("admin/goodsController/v1.0/getIndustrys3").then(res => {
        this.industry_list = res.data || [];
      });
    },
    openProductDialog() {
      this.productKeyword = "";
      this.showHandleProduct = true;
    },
    getProductList() {
      this.post("admin/tag/getTagList", {tag_type: 3, page: -1, pageSize: -1}).then(res => {
        const selectedList = this.submit_form.product ? this.submit_form.product.split(",") : [];
        this.productList = (res.data || []).map(item => Object.assign({}, item, {
          checked: selectedList.indexOf(item.tag_name) !== -1
        }));
      });
    },
    checkProduct(item) {
      item.checked = !item.checked;
    },
    addProduct() {
      this.$prompt("请输入生产产品名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "请输入产品名称"
      }).then(({value}) => {
        const tagName = value.trim();
        this.post("tag/addTag", {
          tag_type: 3,
          tag_name: tagName
        }).then(() => {
          this.$message.success("已添加！");
          this.getProductList();
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "取消输入"
        });
      });
    },
    confirmProduct() {
      const tagNames = this.productList.filter(item => item.checked).map(item => item.tag_name);
      if (!tagNames.length) {
        this.$message.error("请选择产品");
        return;
      }
      this.submit_form.product = tagNames.join(",");
      this.showHandleProduct = false;
      this.$nextTick(() => {
        this.$refs.form.validateField("product");
      });
    },
    querySearchAsync(queryString, cb) {
      if (queryString.length < 4) return cb([]);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.post("companyInterfaces/v1.0/QXBCompanySearch", {company_name: queryString}).then(res => {
          let results = res.data.map(item => {
            return {
              value: item.name,
              credit_no: item.credit_no
            }
          })
          cb(results);
        })
      }, 1000);
    },
    handleSelect(item) {
      this.submit_form.company_taxno = item.credit_no;
    },
    getDictDataList() {
      this.post("dict/getDictDataList", {dict_type_value: "gender"}).then(res => {
        this.sex_list = res.data;
      })
    },

    //    提交
    submit() {
      let isSubmit = false;
      this.$refs.form.validate((valid) => {
        if (!valid) {
          isSubmit = true;
        }
      });
      if (isSubmit) return;

      if (!this.submit_form.company_name) {
        this.$message("请输入公司名称");
        return;
      }
      if (!this.submit_form.industry_ids.length) {
        this.$message("请选择匹配行业");
        return;
      }
      if (!this.submit_form.product) {
        this.$message("请选择生产产品");
        return;
      }
      if (!this.submit_form.company_address) {
        this.$message("请输入详细地址");
        return;
      }

      if (!this.submit_form.agent_name) {
        this.$message("请输入代表人");
        return;
      }
      if (!this.submit_form.contact_name) {
        this.$message("请输入管理员");
        return;
      }
      if (this.submit_form.contact_mobile.length != 11) {
        this.$message("管理员电话应为11位");
        return;
      }
      if (!this.submit_form.contact_position) {
        this.$message("请输入管理员岗位");
        return;
      }

      // ========== 校验设备列表：至少添加一个设备（中间商可不填） ==========
      if (
        !this.isMiddleman &&
        (!this.submit_form.companyDeviceBeans ||
          !this.submit_form.companyDeviceBeans.length)
      ) {
        this.$message.error("请至少添加一个设备");
        return;
      }

      //提交

      this.confirmSubmit();
    },

    //    同意协议
    confirmSubmit() {
      let param = Object.assign({}, this.submit_form);
      if (param.industry_ids && param.industry_ids.length) {
        param.industry_id1 = param.industry_ids[0];
        param.industry_id2 = param.industry_ids[1];
        param.industry_id3 = param.industry_ids[2];
      }
      delete param.industry_ids;
      param.company_province = param.test_address[0];
      param.company_city = param.test_address[1];
      param.company_country = param.test_address[2];
      delete param.test_address;
      param.company_logo = param.company_logo.join(",");
      param.company_certificate_imgs = param.company_certificate_imgs.join(",");
      // ========== 处理设备列表：图片数组转字符串 ==========
      if (param.companyDeviceBeans && param.companyDeviceBeans.length) {
        param.companyDeviceBeans = param.companyDeviceBeans.map((device) => {
          let d = JSON.parse(JSON.stringify(device));
          // 删除仅用于级联选择的 device_id 数组，保留最终的 device_id 值
          // d.device_id 在 confirmDevice 中已被提取为单个值
          // 图片数组转逗号分隔字符串
          if (Array.isArray(d.company_device_img)) {
            d.company_device_img = d.company_device_img.join(",");
          }
          return d;
        });
      }
      if (this.type) {
        param.member_nick_name = param.contact_name;
        param.member_account = param.contact_mobile;
        param.full_invite_code = this.$store.state.memberInfo.invite_code;
        param.sell_id = this.$store.state.memberInfo.member_id;

        param.member_img = "https://img.beltdance.com/app/avatar.png";
        this.jsonPost("companyInterfaces/v1.0/addCustomer", param).then(res => {
          this.$message({
            type: "success",
            message: "添加成功"
          });
          this.back();
        });
      } else {
        this.post("companyInterfaces/v1.0/applyCompany", param).then(res => {
          //    去协议页面
          this.go("/protocol?html_id=3");
        });
      }
    }
  },
  components: {
    "upload-img": UploadImg
  }
};
</script>

<style lang="scss">
.add-company {
  width: 1200px;
  font-size: 14px;
  margin: 0 auto;
  margin-bottom: 138px;

  .page-title {
    padding: 20px;
    margin: 20px 0;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
  }

  .company-form {
    width: 760px;
    margin: 50px auto 0;
  }

  .form-section-title {
    width: 600px;
    margin-left: 160px;
    margin-bottom: 20px;
    padding-left: 10px;
    line-height: 16px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    border-left: 3px solid #409eff;
  }

  .el-form-item {
    width: 600px;
  }

  .el-select {
    width: 100%;
  }

  .product-picker {
    cursor: pointer;

    .el-input__inner {
      cursor: pointer;
    }
  }
}

.product-dialog-body {
  min-height: 260px;
  max-height: 460px;
  overflow-y: auto;
  padding: 20px 30px 10px;

  .product-tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .product-tag {
    display: inline-flex;
    align-items: center;
    min-height: 36px;
    padding: 8px 15px;
    border-radius: 6px;
    color: #666666;
    background: #f5f5f5;
    cursor: pointer;
    transition: background-color .2s, color .2s;

    &.active {
      color: #ffffff;
      background-color: #458ef6;
    }
  }

  .product-empty {
    padding: 50px 0;
    text-align: center;
    color: #999999;
  }
}

</style>



// WEBPACK FOOTER //
// src/page/register/ApplyCompany.vue